import React from "react";
import { ProgressTracker } from "@atlaskit/progress-tracker";

const ProgressTrack = ({ data }) => {
  const items = [
    {
      id: "1",
      label: "Recovery action",
      percentageComplete: data.whatToRestore === "unvisited" ? 0 : 100,
      status: data.whatToRestore,
      href: "#",
      noLink: true,
    },
    {
      id: "2",
      label: "Snapshot",
      percentageComplete: data.dataToRestoreFrom === "unvisited" ? 0 : 100,
      status: data.dataToRestoreFrom,
      href: "#",
      noLink: true,
    },
    {
      id: "3",
      label: "Filters",
      percentageComplete: data.filterData === "unvisited" ? 0 : 100,
      status: data.filterData,
      href: "#",
      noLink: true,
    },
    {
      id: "4",
      label: "Preview",
      percentageComplete: data.previewData === "unvisited" ? 0 : 100,
      status: data.previewData,
      href: "#",
      noLink: true,
    },
    {
      id: "5",
      label: "Recover",
      percentageComplete: 0,
      status: data.restoreData,
      href: "#",
      noLink: true,
    },
  ];
  return (
    <div>
      <ProgressTracker items={items} spacing="cosy" />
    </div>
  );
};

export default ProgressTrack;
